import type { TypedDocumentNode } from "@apollo/client";
import gql from "graphql-tag";

export type GetWarehousesListQuery = {
  getAllWarehouses: Array<{
    id: string
    name: string
    full_name: string | null
    ns_id: string | null
    created_at: string
    updated_at: string
    deleted_at: string | null
  }>
};

export const GET_WAREHOUSES_LIST: TypedDocumentNode<GetWarehousesListQuery> = gql`
  query getAllWarehouses {
    getAllWarehouses {
      id
      name
      full_name
      ns_id
      created_at
      updated_at
      deleted_at
    }
  }
`;
